import React, {useRef, useState, useEffect} from "react";
import Tooltip from "@mui/material/Tooltip";

const TruncatedWithTooltip = ({text, className = "", maxWidth = "300px"}) => {
    const divRef = useRef(null);
    const [isOverflowing, setIsOverflowing] = useState(false);

    useEffect(() => {
        const el = divRef.current;
        if (el) {
            setIsOverflowing(el.scrollWidth > el.clientWidth);
        }
    }, [text]);
    const renderComponent = () => {
        return (<div
                ref={divRef}
                className={`truncate ${className}`}
                style={{maxWidth}}
            > {text} </div>)
    }

    return (isOverflowing ? <Tooltip
            key={text}
            title={text}
            placement="top"


            slotProps={{
                popper: {
                    sx: {
                        zIndex: 2147483647,
                    },
                    modifiers: [{
                        name: 'offset', options: {
                            offset: [0, -8],
                        },
                    },],
                }, tooltip: {
                    className: "!text-[16px] !text-main-normal !bg-background-normal !border !border-panels-normal !shadow-lg !rounded-input",
                    sx: { maxWidth: 'none' }
                }
            }}
        >
            {renderComponent()}
        </Tooltip> : renderComponent());
};

export default TruncatedWithTooltip